<template>
  <!-- 企業検診データ抽出 -->
  <div id="KenshinExtractData">
    <div id="container">
      <kenshinNavi v-bind:pageid='"KenshinExtractData"'></kenshinNavi>
      <div class="kenshinLabelTitle lable">企業検診 データ抽出</div>
      <div class="condition-area" v-if="!extractDataFlag">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" id="receiptNumber" v-model="searchConditions.receiptNumber"/></td>
            <th>デモ</th>
            <td><select id="demo" v-model="searchConditions.demo"><option></option><option value="false">含まない</option><option value="true">デモのみ</option></select></td>
            <th>機種</th>
            <td><select id="model" v-model="searchConditions.model"><option v-for="device in kenshinDeviceList" :value="device.value" :key="device.value">{{ device.label1 }}</option></select></td>
            <th>依頼元種別</th>
            <td><select id="clientType" v-model="searchConditions.clientType"><option></option><option :value="role.role_corporation">企業</option><option :value="role.role_dealer">ディーラー</option><option :value="role.role_hospital">医療機関</option><option :value="role.role_accommodations">宿泊施設</option></select></td>
          </tr>
          <tr>
            <th>依頼元</th>
            <td><input type="text" id="client" v-model="searchConditions.client"/></td>
            <th>企業名</th>
            <td><input type="text" id="corporation" v-model="searchConditions.companyName"/></td>
            <th>申込日</th>
            <td colspan="3"><input type="date" id="applicationDateStart" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" id="applicationDateEnd" v-model="searchConditions.applicationDateEnd"/></td>
          </tr>
          <tr>
            <th>シリアル番号</th>
            <td><input type="text" v-model="searchConditions.serial" id="serialInput" @keyup.enter="onKeyupEnter()"/></td>
            <th>判定有無</th>
            <td><select id="judgementFlag" v-model="searchConditions.judgementFlag"><option value=""></option><option value="0">無</option><option value="1">有</option></select></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult && !extractDataFlag">
        <b-table
            id="kenshinExtractDataTable"
            :data="searchDatas"
            :paginated="isPaginated"
            per-page="50"
            pagination-position="both"
            default-sort="receiptNumber"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column field="deviceInfo.receiptNumber" label="受付番号" width="60" sortable centered>
                <!-- {{props.row.deviceInfo.receiptNumber}} -->
                <a class="btn btn-danger" href="javascript:" @click="extractData(props.row)">{{props.row.deviceInfo.receiptNumber}}</a>
              </b-table-column>
              <b-table-column field="deviceInfo.serial" label="シリアル" width="60" sortable centered>
                {{props.row.deviceInfo.serial}}
              </b-table-column>
              <b-table-column field="deviceInfo.patientName" label="患者名" width="80" sortable centered>
                {{props.row.deviceInfo.patientName}}
              </b-table-column>
              <b-table-column field="deviceInfo.instrumentKind" label="機種" width="80" sortable centered>
                {{props.row.deviceInfo.instrumentKind}}
              </b-table-column>
              <b-table-column field="deviceInfo.officeName" label="企業名" width="200" sortable centered>
                {{props.row.deviceInfo.companyName}}{{props.row.deviceInfo.officeName}}
              </b-table-column>
            </template>
        </b-table>
      </div>
      <!-- データ抽出用画面 -->
      <div id="item-contens" class="result-area" v-else-if="extractDataFlag && data.deviceInfo">
        <div class="labelTitle lable">抽出データ登録</div>
        <div class="card-content margin-top">
          <span style="font-size:20px;">機器情報</span>
          <table>
            <tr><th>機種</th><td>{{data.deviceInfo.instrumentKind}}</td><th>名前<span class="require" /></th><td><input type="text" v-model="data.deviceInfo.patientName" maxlength="100" class="inputArea" name="名前" validate="required"/></td></tr>
            <tr><th>シリアル</th><td>{{data.deviceInfo.serial}}</td><th>性別<span/></th><td>
              <div class="block">
                <b-radio class="td_radio" v-model="data.deviceInfo.gender" native-value="-">-</b-radio>
                <b-radio class="td_radio" v-model="data.deviceInfo.gender" native-value="男">男</b-radio>
                <b-radio class="td_radio" v-model="data.deviceInfo.gender" native-value="女">女</b-radio>
              </div></td>
            </tr>
            <tr>
              <th>受付番号</th><td>{{data.deviceInfo.receiptNumber}}</td>
              <th>生年月日</th><td><input type="date" v-model="data.deviceInfo.birthday" :max="yyyy_hyp_MM_hyp_dd(new Date())" :input="inputBirthday(data.deviceInfo.birthday)" class="inputArea" name="生年月日" validate="date|birthDay"/></td>
            </tr>
            <tr><th>企業名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word; width:30%;">{{data.deviceInfo.companyName}} {{data.deviceInfo.officeName}}</td><th>年齢</th><td>{{data.deviceInfo.age}}</td></tr>
            <tr><th>社員番号</th><td><input class="td_txt" type="text" v-model="data.deviceInfo.employeeNo" maxlength="100"/></td><th style="vertical-align:top;">備考</th><td><textarea maxlength="256" style="resize:vertical;max-width:100%;" v-model="data.deviceInfo.biko"></textarea></td></tr>
            <tr><th style="vertical-align:top;">検診情報備考</th>
            <td colspan="3">{{data.deviceInfo.kenshinNote}}</td>
            </tr>
            <tr><th style="vertical-align:top;">検診グループ受付備考</th>
            <td colspan="3">{{data.deviceInfo.businessBiko}}</td>
            </tr>
            <tr><th style="vertical-align:top;">川越受付備考</th>
            <td colspan="3">
              <div style="color:red;">{{data.deviceInfo.remarks}}</div>
              {{data.deviceInfo.kawagoeNote}}
            </td>
            </tr>
            <tr>
              <th style="vertical-align:top;">外部ユーザーコメント</th>
              <td colspan="3" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.deviceInfo.belongsNote}}</td>
            </tr>
          </table>
        </div>
        <div v-if="screeningFlag" class="card-content margin-top">
          <span style="font-size:20px;">診断結果送付先</span>
          <table>
            <tr>
              <th>郵便番号<span class="require" /></th>
              <td>
                <input
                  style="width: 300px;"
                  type="text"
                  v-model="data.resultDeliveryInfo.resultDeliveryZip"
                  maxlength="7"
                  class="inputArea"
                  :class="{'border-red': invalidPostcode}"
                  name="郵便番号"
                  validate="required|numeric"
                  :placeholder="postcodePlaceholder"
                />
                <b-button class="passButton" v-on:click="addressSearch(data.resultDeliveryInfo.resultDeliveryZip)">郵便番号検索</b-button>
                <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
              </td>
            </tr>
            <tr>
              <th>住所<span class="require" /></th>
              <td><input type="text" v-model="data.resultDeliveryInfo.resultDeliveryAddress" maxlength="256" class="inputArea" name="住所" validate="required"/></td>
            </tr>
            <tr>
              <th>宛名<span class="require" /></th>
              <td><input type="text" v-model="data.resultDeliveryInfo.resultDeliveryName" maxlength="100" class="inputArea" name="宛名" validate="required"/></td>
            </tr>
          </table>
        </div>
        <div class="card-content margin-top">
          <span style="font-size:20px;">測定結果</span>
          <table v-if="isWP">
            <tr>
              <td colspan="4" >
                <div style=" display: flex; margin-bottom:5px;">
                  <div class="upload_area" @dragenter="dragEnter(true)">
                    <span class="upload_span">ここに測定データをドラッグアンドドロップするか、「ファイル読込み」を押します。</span>
                  </div>
                  <b-modal :active.sync="isUpdateCSVModal" has-modal-card>
                    <div class="modal-card uploadModal"
                      @dragleave="dragLeave(true)"
                      @drop.prevent="fileDoropCSV"
                    >ここに添付するレポートファイルをドロップします。</div>
                  </b-modal>
                  <b-upload v-model="upButtonFile"  class="file-label" v-on:input="readCSV" multiple style="margin-left:10px;">
                    <span class="file-cta" style="background-color:(133,133,133);border-color:black;">
                      <span class="file-label">ファイル読込み</span>
                    </span>
                  </b-upload>
                </div>
              </td>
            </tr>
            <tr><th>検査ID</th><td><input class="resultInput" type="text" v-model="data.measurementResult.inspectionId" maxlength="100"/></td><th>ODI4</th><td><input class="resultInput" type="text" v-model="data.measurementResult.odi4" maxlength="20"/></td></tr>
            <tr><th>身長</th><td><input class="resultInput" type="text" v-model="data.measurementResult.height" maxlength="20"/></td><th>RDI</th><td><input class="resultInput" type="text" v-model="data.measurementResult.rdi" maxlength="20"/></td></tr>
            <tr><th>体重</th><td><input class="resultInput" type="text" v-model="data.measurementResult.weight" maxlength="20"/></td><th>AHI</th><td><input class="resultInput" type="text" v-model="data.measurementResult.ahi" maxlength="20"/></td></tr>
            <tr><th>BMI</th><td><input class="resultInput" type="text" v-model="data.measurementResult.bmi" maxlength="20"/></td><th>脈拍平均</th><td><input class="resultInput" type="text" v-model="data.measurementResult.pulseAverage" maxlength="20"/></td></tr>
            <tr><th>開始日</th><td><input class="resultInput" type="text" v-model="data.measurementResult.startDate" maxlength="20"/></td><th>脈拍最低</th><td><input class="resultInput" type="text" v-model="data.measurementResult.pulseLowest" maxlength="20"/></td></tr>
            <tr><th>開始時間</th><td><input class="resultInput" type="text" v-model="data.measurementResult.startTime" maxlength="20"/></td><th>酸素90未満</th><td><input class="resultInput" type="text" v-model="data.measurementResult.oxygenLess90" maxlength="20"/></td></tr>
            <tr><th>終了日</th><td><input class="resultInput" type="text" v-model="data.measurementResult.endDate" maxlength="20"/></td><th>酸素88未満</th><td><input class="resultInput" type="text" v-model="data.measurementResult.oxygenLess88" maxlength="20"/></td></tr>
            <tr><th>終了時間</th><td><input class="resultInput" type="text" v-model="data.measurementResult.endTime" maxlength="20"/></td><th>酸素85未満</th><td><input class="resultInput" type="text" v-model="data.measurementResult.oxygenLess85" maxlength="20"/></td></tr>
            <tr><th>測定時間</th><td><input class="resultInput" type="text" v-model="data.measurementResult.measurementTime" maxlength="20"/></td><th>酸素80未満</th><td><input class="resultInput" type="text" v-model="data.measurementResult.oxygenLess80" maxlength="20"/></td></tr>
            <tr><th>睡眠時間</th><td><input class="resultInput" type="text" v-model="data.measurementResult.sleepTime" maxlength="20"/></td><th>酸素70未満</th><td><input class="resultInput" type="text" v-model="data.measurementResult.oxygenLess70" maxlength="20"/></td></tr>
            <tr><th>SPO2中央</th><td><input class="resultInput" type="text" v-model="data.measurementResult.SPO2Center" maxlength="20"/></td><th>いびき40dB率</th><td><input class="resultInput" type="text" v-model="data.measurementResult.snoring40dBRate" maxlength="20"/></td></tr>
            <tr><th>SPO2最低</th><td><input class="resultInput" type="text" v-model="data.measurementResult.SPO2Minimum" maxlength="20"/></td><th>セルフチェック</th><td><input class="resultInput" type="text" v-model="data.measurementResult.selfCheck" maxlength="20"/></td></tr>
          </table>
          <table v-else-if="isSimonJ">
            <tr>
              <td colspan="4" >
                <div style=" display: flex; margin-bottom:5px;">
                  <div class="upload_area" @dragenter="dragEnter(true)">
                    <span class="upload_span">ここに測定データをドラッグアンドドロップするか、「ファイル読込み」を押します。</span>
                  </div>
                  <b-modal :active.sync="isUpdateCSVModal" has-modal-card>
                    <div class="modal-card uploadModal"
                      @dragleave="dragLeave(true)"
                      @drop.prevent="fileDoropCSV"
                    >ここに添付するレポートファイルをドロップします。</div>
                  </b-modal>
                  <b-upload v-model="upButtonFile"  class="file-label" v-on:input="readCSV" multiple style="margin-left:10px;">
                    <span class="file-cta" style="background-color:(133,133,133);border-color:black;">
                      <span class="file-label">ファイル読込み</span>
                    </span>
                  </b-upload>
                </div>
              </td>
            </tr>
            <tr><th>患者ID</th><td><input class="resultInput" type="text" v-model="data.measurementResult.inspectionId" maxlength="100"/></td><th>解析時間</th><td><input class="resultInput" type="text" v-model="data.measurementResult.analysisTime" maxlength="20"/></td></tr>
            <tr><th>身長</th><td><input class="resultInput" type="text" v-model="data.measurementResult.height" maxlength="20"/></td><th>ODI3</th><td><input class="resultInput" type="text" v-model="data.measurementResult.odi3" maxlength="20"/></td></tr>
            <tr><th>体重</th><td><input class="resultInput" type="text" v-model="data.measurementResult.weight" maxlength="20"/></td><th>SPO2平均値</th><td><input class="resultInput" type="text" v-model="data.measurementResult.SPO2Center" maxlength="20"/></td></tr>
            <tr><th>BMI</th><td><input class="resultInput" type="text" v-model="data.measurementResult.bmi" maxlength="20"/></td><th>SPO2最低値</th><td><input class="resultInput" type="text" v-model="data.measurementResult.SPO2Minimum" maxlength="20"/></td></tr>
            <tr><th>測定日</th><td><input class="resultInput" type="text" v-model="data.measurementResult.startDate" maxlength="20"/></td><th>SPO2低下数</th><td><input class="resultInput" type="text" v-model="data.measurementResult.SPO2Declines" maxlength="20"/></td></tr>
            <tr><th>開始時刻</th><td><input class="resultInput" type="text" v-model="data.measurementResult.startTime" maxlength="20"/></td><th>脈拍平均</th><td><input class="resultInput" type="text" v-model="data.measurementResult.pulseAverage" maxlength="20"/></td></tr>
            <tr><th>測定時間</th><td><input class="resultInput" type="text" v-model="data.measurementResult.measurementTime" maxlength="20"/></td><th>セルフチェック</th><td><input class="resultInput" type="text" v-model="data.measurementResult.selfCheck" maxlength="20"/></td></tr>
          </table>
          <table v-else>
            <tr>
              <td colspan="4" >
                <div style=" display: flex; margin-bottom:5px;">
                  <div class="upload_area" @dragenter="dragEnter(true)">
                    <span class="upload_span">ここに測定データをドラッグアンドドロップするか、「ファイル読込み」を押します。</span>
                  </div>
                  <b-modal :active.sync="isUpdateCSVModal" has-modal-card>
                    <div class="modal-card uploadModal"
                      @dragleave="dragLeave(true)"
                      @drop.prevent="fileDoropCSV"
                    >ここに添付するレポートファイルをドロップします。</div>
                  </b-modal>
                  <b-upload v-model="upButtonFile"  class="file-label" v-on:input="readCSV" multiple style="margin-left:10px;">
                    <span class="file-cta" style="background-color:(133,133,133);border-color:black;">
                      <span class="file-label">ファイル読込み</span>
                    </span>
                  </b-upload>
                </div>
              </td>
            </tr>
            <tr><th>検査ID</th><td><input class="resultInput" type="text" v-model="data.measurementResult.inspectionId" maxlength="100"/></td><th>睡眠時間</th><td><input class="resultInput" type="text" v-model="data.measurementResult.sleepTime" maxlength="20"/></td></tr>
            <tr><th>身長</th><td><input class="resultInput" type="text" v-model="data.measurementResult.height" maxlength="20"/></td><th>SPO2中央</th><td><input class="resultInput" type="text" v-model="data.measurementResult.SPO2Center" maxlength="20"/></td></tr>
            <tr><th>体重</th><td><input class="resultInput" type="text" v-model="data.measurementResult.weight" maxlength="20"/></td><th>SPO2最低</th><td><input class="resultInput" type="text" v-model="data.measurementResult.SPO2Minimum" maxlength="20"/></td></tr>
            <tr><th>BMI</th><td><input class="resultInput" type="text" v-model="data.measurementResult.bmi" maxlength="20"/></td><th>ODI4</th><td><input class="resultInput" type="text" v-model="data.measurementResult.odi4" maxlength="20"/></td></tr>
            <tr><th>開始日</th><td><input class="resultInput" type="text" v-model="data.measurementResult.startDate" maxlength="20"/></td><th>ODI3</th><td><input class="resultInput" type="text" v-model="data.measurementResult.odi3" maxlength="20"/></td></tr>
            <tr><th>開始時間</th><td><input class="resultInput" type="text" v-model="data.measurementResult.startTime" maxlength="20"/></td><th>ODI2</th><td><input class="resultInput" type="text" v-model="data.measurementResult.odi2" maxlength="20"/></td></tr>
            <tr><th>終了日</th><td><input class="resultInput" type="text" v-model="data.measurementResult.endDate" maxlength="20"/></td><th>&lt;90%時間</th><td><input class="resultInput" type="text" v-model="data.measurementResult.lessThan90Time" maxlength="20"/></td></tr>
            <tr><th>終了時間</th><td><input class="resultInput" type="text" v-model="data.measurementResult.endTime" maxlength="20"/></td><th>&lt;90%割合</th><td><input class="resultInput" type="text" v-model="data.measurementResult.lessThan90Ratio" maxlength="20"/></td></tr>
            <tr><th>測定時間</th><td><input class="resultInput" type="text" v-model="data.measurementResult.measurementTime" maxlength="20"/></td><th>脈拍中央</th><td><input class="resultInput" type="text" v-model="data.measurementResult.pulseAverage" maxlength="20"/></td></tr>
            <tr><th>セルフチェック</th><td><input class="resultInput" type="text" v-model="data.measurementResult.selfCheck" maxlength="20"/></td></tr>
          </table>
        </div>
        <div class="card-content margin-top" v-if="data.judgementFlag">
          <span style="font-size:20px;">解析レポート</span>
          <table>
            <tr><td>
              <div style=" display: flex; margin-bottom:5px;">
                <div class="upload_area" @dragenter="dragEnter(false)">
                  <span class="upload_span">ここに添付するレポートをドラッグアンドドロップするか、「レポート追加」を押します。</span>
                </div>
                <b-modal :active.sync="isUpdateModal" has-modal-card>
                  <div class="modal-card uploadModal"
                   @dragleave="dragLeave(false)"
                   @drop.prevent="fileDorop"
                  >ここに添付するレポートファイルをドロップします。</div>
                </b-modal>
                <b-upload v-model="upButtonFile"  class="file-label" v-on:input="addUploadfile" multiple style="margin-left:10px;">
                  <span class="file-cta" style="background-color:(133,133,133);border-color:black;">
                    <span class="file-label">レポート追加</span>
                  </span>
                </b-upload>
              </div>
            </td></tr>
          </table>
          <table>
            <template v-for="(report,index) of data.analysisResultFileList">
              <tr :key="index">
                <td style="width:400px"><span><b-icon icon="paperclip"/></span>{{report.name}}
                <a @click="deleteUpfile(index)"><b-icon icon="delete-forever-outline " /></a></td>
              </tr>
            </template>
          </table>
        </div>
        <div class="button-area">
          <b-button class="opButton is-primary" icon-left="content-save" @click="dataSave">データ登録</b-button>
          <b-button class="opButton is-primary" icon-left="file-question-outline" @click="reasonInputModalActive=true">データなし(再検査調整)</b-button>
          <b-button class="opButton is-primary" icon-left="file-remove-outline" @click="cancelReasonInputModalActive=true">検査をキャンセル</b-button>
          <b-button class="opButton is-primary" style="margin-left:20%;" @click="doSearch">検索一覧に戻る</b-button>
        </div>
        <b-modal :active.sync="reasonInputModalActive" has-modal-card>
          <reasonInputModal  v-on:setReason="reExaminationAdjustment" v-bind:title="'再検査調整(再検査理由入力)'"></reasonInputModal>
        </b-modal>
        <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
          <reasonInputModal  v-on:setReason="cancel" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/kenshin/KenshinNaviBar";
import {
  choicesType,
  role,
  UploadType,
  invalidNumberMessage,
  postcodePlaceholder,
} from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";

export default {
  name: "KenshinExtractData",
  methods: {
    onKeyupEnter: function(){
      //シリアルを取得
      let serialItems = this.searchConditions.serial.split('/');
      if(serialItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        this.searchConditions.serial = serialItems[1]
      }
    },
    doSearch: async function(){
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.searchDatas = []
      this.data = {}
      this.extractDataFlag = false
      this.hasResult = false;
      var excuteApi = this.getKenshinDataExtractionPOST;
      var successCallBack = this.getKenshinDataExtractionPOSTSuccess;
      var errorCallBack = this.getKenshinDataExtractionPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinDataExtractionPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      if(!obj.clientType){
        delete obj.clientType
      }
      return client.apis.internalKenshin.getKenshinDataExtractionPOST({ 
        body:obj
      });
    },
    getKenshinDataExtractionPOSTSuccess: function(result) {
      this.searchDatas = result.obj
      if(this.searchDatas.length > 0){
        this.hasResult = true;
      }
    },
    getKenshinDataExtractionPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    extractData: function(rowData) {
      this.data = rowData
      this.screeningFlag = this.data.screeningFlag
      this.isWP = false
      this.isSimonJ = false
      if(this.data.deviceInfo.instrumentKind.indexOf("ウォッチパット") != -1){
        this.isWP = true
      }else if(this.data.deviceInfo.instrumentKind.indexOf("サイモンJ") != -1){
        this.isSimonJ = true
      }
      this.extractDataFlag = true
    },
    inputBirthday: function(birthday){
      var age = this.getAge(birthday)
      if(!isNaN(Number(age))){
        this.data.deviceInfo.age = age < 0 ? 0 : age
      }else{
        this.data.deviceInfo.age = ""
      }
    },
    addressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        this.data.resultDeliveryInfo.resultDeliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.searchTargetPostCode = ""
    },
    dataSave: async function() {
      // バリデーションチェック
      var elements = document.getElementsByClassName("inputArea")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if (errMsg != ""){
        this.showErrorMessage(errMsg)
        return
      }
      var targetFile = this.data.analysisResultFileList.filter(val => !val.fileId)
      const nameList = targetFile.map(item => item['path']);
      for(let i = 0; i < nameList.length; i++){
        if(nameList[i].startsWith("/")){
          let zipName = nameList[i].replace("/", "");
          nameList[i] = zipName + ".zip"
        }
      }
      const setElements = new Set(nameList);
      if (setElements.size !== nameList.length) {
        this.showErrorMessage("解析レポートの重複しているファイルが存在します。")
        return
      }
      let okSize = await this.checkUploadFileSize(targetFile);
      if(!okSize){
        this.showErrorMessage("2GBを超えるファイルはアップロードできません。");
        return
      }

      //まずはファイルのアップロードから
      let uploadSuccess = true;
      if(targetFile.length > 0){
        await this.multipleUpload(targetFile ,this.data.deviceInfo.receiptNumber, this.UploadType.kenshin_report)
        .catch(error =>{
          this.showErrorMessage("ファイルアップロードに失敗した為、申込みをキャンセルしました。<br>再度実行してください。");
          uploadSuccess = false;
        });
     }
     if(uploadSuccess){
        // データ登録
        var excuteApi = this.setKenshinDataExtractionPOST;
        var successCallBack = this.setKenshinDataExtractionPOSTSuccess;
        var errorCallBack = this.setKenshinDataExtractionPOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
     }
    },
    setKenshinDataExtractionPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      delete obj.analysisResultFileList
      obj.deviceInfo.birthday = obj.deviceInfo.birthday ? obj.deviceInfo.birthday.replace(/-/g, "/") : "";
      obj.deviceInfo.age = obj.deviceInfo.age + "";
      return client.apis.internalKenshin.setKenshinDataExtractionPOST({
        body:obj
      });
    },
    setKenshinDataExtractionPOSTSuccess: function(result) {
      this.showMessage("抽出データの登録を実施しました。");
      this.data = {}
      this.extractDataFlag = false
      this.doSearch()
    },
    setKenshinDataExtractionPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    reExaminationAdjustment: function(reason) {
      // データなし(再検査調整)
      this.reason = reason
      var excuteApi = this.setKenshinInspectionAdjustmentPOST;
      var successCallBack = this.setKenshinInspectionAdjustmentPOSTSuccess;
      var errorCallBack = this.setKenshinInspectionAdjustmentPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinInspectionAdjustmentPOST: function(client) {
      return client.apis.internalKenshin.setKenshinInspectionAdjustmentPOST({
        body:{
          receiptNumber:this.data.deviceInfo.receiptNumber,
          reason:this.reason,
          version:this.data.version
        }
      });
    },
    setKenshinInspectionAdjustmentPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.data = {}
      this.reason = ""
      this.extractDataFlag = false
      this.doSearch()
    },
    setKenshinInspectionAdjustmentPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.reason = ""
    },
    cancel: function(cancelReason) {
      // 検査をキャンセル
      this.reason = cancelReason
      var excuteApi = this.setKenshinInspectionCancelPOST;
      var successCallBack = this.setKenshinInspectionCancelPOSTSuccess;
      var errorCallBack = this.setKenshinInspectionCancelPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinInspectionCancelPOST: function(client) {
      return client.apis.internalKenshin.setKenshinInspectionCancelPOST({
        body:{
          receiptNumber:this.data.deviceInfo.receiptNumber,
          reason:this.reason,
          version:this.data.version
        }
      });
    },
    setKenshinInspectionCancelPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.data = {}
      this.reason = ""
      this.extractDataFlag = false
      this.doSearch()
    },
    setKenshinInspectionCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.reason = ""
    },
    dragEnter: function(isCSVflg) {
      if(isCSVflg){
        this.isUpdateCSVModal = true;
      }else{
        this.isUpdateModal = true;
      }
    },
    dragLeave: function(isCSVflg) {
      if(isCSVflg){
        this.isUpdateCSVModal = false;
      }else{
        this.isUpdateModal = false;
      }
    },
    fileDorop: async function(event) {
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        let path = entry.name;
        if(entry.isDirectory){
          path = entry.fullPath;
        }
        this.data.analysisResultFileList.push({ file: entry, path: path, name:path })
      }

      this.isUpdateModal = false;
    },
    fileDoropCSV: async function(event) {
      await this.analysisCSV(event.dataTransfer.files[0])
      this.isUpdateCSVModal = false;
    },
    addUploadfile: function(){
      for(let upFile of this.upButtonFile){
        this.data.analysisResultFileList.push({ file: upFile, path: upFile.name,name:upFile.name })
      }
      this.upButtonFile = [];
    },
    deleteUpfile: function(index){
      this.data.analysisResultFileList.splice(index, 1);
      // this.$set(this.reqParams.analysisDataInfo,"attachedDataFileList",this.reqParams.analysisDataInfo.attachedDataFileList)
    },
    readCSV: async function(){
      await this.analysisCSV(this.upButtonFile[0])
      this.upButtonFile = [];
    },
    analysisCSV: async function(file){
      if(this.data.deviceInfo.instrumentKind.indexOf("ウォッチパット") != -1){
        // ウォッチパット用CSV読込
        await this.readFileWP(file)
      }else if(this.data.deviceInfo.instrumentKind.indexOf("PULSOX") != -1){
        // PULSOX用DIFファイル読込
        await this.readFilePULSOX(file)
      }else if(this.data.deviceInfo.instrumentKind.indexOf("パルスウォッチ") != -1){
        // パルスウォッチ用CSV読込
        await this.readFilePMP(file)
      }else if(this.data.deviceInfo.instrumentKind.indexOf("サイモンJ") != -1){
        // サイモンJ用CSV読込
        await this.readFileSimonJ(file)
      }
    },
    readFileWP: async function(file){
      var appVue = this.$root.$children[0]
      let _this = this
      const columnDef =  {
        'inspectionId': 0,
        'height': 17,
        'weight': 18,
        // 'bmi': ,
        'startDate': 25,
        'startTime': 48,
        'endDate': 26,
        'endTime': 49,
        // 'measurementTime': 51,
        'sleepTime': 50,
        'SPO2Center': 73,
        'SPO2Minimum': 74,
        'odi4': 57,
        'rdi': 54,
        'ahi': 55,
        'pulseAverage': 90,
        'pulseLowest': 91,
        'oxygenLess90': 84,
        'oxygenLess88': 86,
        'oxygenLess85': 87,
        'oxygenLess80': 88,
        'oxygenLess70': 89,
        'snoring40dBRate':123,
        'selfCheck':33
      }
      // ロード中か判定
      if (!appVue.$data.isLoading) {
        appVue.loadingStart()
      }
      
      // FileReader オブジェクトを作成
      let reader = new FileReader();
      reader.readAsText(file,'shift-jis');
      reader.onload = function() {
        try{
          var recordArray =  reader.result.split('\n');
          let columns = recordArray[1].split(',');
          var bmi = ""
          var height = columns[columnDef.height]
          var weight = columns[columnDef.weight]
          if(height != "" && weight != "" && height != 0 && weight != 0){
            var workheight = height/ 100;
            bmi = weight / (workheight * workheight);
            if(bmi){
              // 小数点第2位で四捨五入
              bmi = bmi.toFixed(1)
            }
          }

          var startTime = columns[columnDef.startTime]
          var endTime = columns[columnDef.endTime]
          var measurementTime = ""
          if(startTime && endTime){
            var startTimes = startTime.split(':')
            var startTimesecond = Number(startTimes[0]+startTimes[1]+startTimes[2]);
            var endTimes = endTime.split(':')
            var endTimesecond = Number(endTimes[0]+endTimes[1]+endTimes[2]);
            if(endTimesecond < startTimesecond){
              endTime = (Number(endTimes[0])+24) + ':' + endTimes[1] + ':' + endTimes[2]
            }
            measurementTime = _this.subTime(endTime,startTime)
          }
          let item =  {
            inspectionId:columns[columnDef.inspectionId].split('"')[1],
            height:height,
            weight:weight,
            bmi:bmi,
            startDate: _this.convertDateFormat(columns[columnDef.startDate]),
            startTime: columns[columnDef.startTime],
            endDate:"",
            endTime:columns[columnDef.endTime],
            measurementTime:measurementTime,
            sleepTime:columns[columnDef.sleepTime],
            SPO2Center:columns[columnDef.SPO2Center],
            SPO2Minimum:columns[columnDef.SPO2Minimum],
            odi4:columns[columnDef.odi4],
            rdi:columns[columnDef.rdi],
            ahi:columns[columnDef.ahi],
            pulseAverage:columns[columnDef.pulseAverage],
            pulseLowest:columns[columnDef.pulseLowest],
            oxygenLess90:columns[columnDef.oxygenLess90],
            oxygenLess88:columns[columnDef.oxygenLess88],
            oxygenLess85:columns[columnDef.oxygenLess85],
            oxygenLess80:columns[columnDef.oxygenLess80],
            oxygenLess70:columns[columnDef.oxygenLess70],
            snoring40dBRate:columns[columnDef.snoring40dBRate],
            selfCheck:columns[columnDef.selfCheck].split('"')[1]
          }
          // 取込内容のセット
          _this.$set(_this.data,"measurementResult",item)
          var targetName = columns[2] + columns[1]
          if(_this.data.deviceInfo.patientName.replaceAll("　","").replaceAll(" ","") != targetName.replaceAll("　","").replaceAll(" ","").replaceAll('"','')){
            _this.showErrorMessage("被験者の名前が一致しません。\nCSVファイルの内容が正しいか確認してください。")
          }
          appVue.loadingEnd()
        }catch(err){
          console.log(err)
          appVue.loadingEnd()
          _this.showErrorMessage("CSV読み込み中にエラーが発生しました。\nCSVファイルの内容が正しいか確認して、再度読み込み直してください。")
          return
        }
      };

      reader.onerror = function() {
        console.log("読込エラー")
        appVue.loadingEnd()
        _this.showErrorMessage("CSV読み込み中にエラーが発生しました。\nCSVファイルの内容が正しいか確認して、再度読み込み直してください。")
      return
      };
    },
    readFilePULSOX: async function(file){
      var appVue = this.$root.$children[0]
      let _this = this
      const columnDef =  {
        281:'inspectionId',
        289:'height',
        291:'weight',
        293:'bmi',
        335:'startDate',
        337:'startTime',
        // 'endDate': ,
        // 'endTime': ,
        339:'measurementTime',
        351:'selfCheck',
        395:'sleepTime',
        415:'SPO2Center',
        445:'SPO2Minimum',
        425:'odi4',
        433:'odi3',
        441:'odi2',
        453:'lessThan90Time',
        459:'lessThan90Ratio',
        509:'pulseAverage'
      }
      var patientName = ""
      var item = {}
      // ロード中か判定
      if (!appVue.$data.isLoading) {
        appVue.loadingStart()
      }
      // FileReader オブジェクトを作成
      let reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function() {
        try{
          var recordArray =  reader.result.split('\n');
          for (let i = 0; i < recordArray.length; i++){
            if(!columnDef[i]){
              if(i==279){
                patientName = recordArray[i].split('"')[1];
              }
              continue
            }
            let column = recordArray[i].split('"')[1];
            item[columnDef[i]] = column
          }
          if(item["height"]){
            item["height"] = item["height"] * 100
          }
          if(item["startDate"] && item["startTime"] && item["measurementTime"]){
            var year = item["startDate"].split("/")[0]
            var month = item["startDate"].split("/")[1] + 1
            var day = item["startDate"].split("/")[2]
            var hour = item["startTime"].split(":")[0]
            var minutes = item["startTime"].split(":")[1]
            var seconds = item["startTime"].split(":")[2]
            var workDay = new Date(year,month,day,hour,minutes,seconds)
            item["measurementTime"].split(":")[0]
            item["measurementTime"].split(":")[1]
            item["measurementTime"].split(":")[2]
            workDay.setHours(workDay.getHours()+item["measurementTime"].split(":")[0])
            workDay.setMinutes(workDay.getMinutes()+item["measurementTime"].split(":")[1])
            workDay.setSeconds(workDay.getSeconds()+item["measurementTime"].split(":")[2])
            // var endDate = "yyyy/MM/dd"
            // endDate = endDate.replace(/yyyy/g, workDay.getFullYear())
            // endDate = endDate.replace(/MM/g, ('0' + (workDay.getMonth() + 1)).slice(-2))
            // endDate = endDate.replace(/dd/g, ('0' + workDay.getDate()).slice(-2))
            // var endTime = workDay.getHours() + ":" + workDay.getMinutes() + ":" + workDay.getSeconds()
            // item["endDate"] = endDate
            // item["endTime"] = endTime
            item["endDate"] = ""
            item["endTime"] = ""
          }
          
          // 取込内容のセット
          _this.$set(_this.data,"measurementResult",item)
          if(_this.data.deviceInfo.patientName.replaceAll("　","").replaceAll(" ","")!=patientName.replaceAll("　","").replaceAll(" ","")){
            _this.showErrorMessage("被験者の名前が一致しません。\nDIFファイルの内容が正しいか確認してください。")
          }
          appVue.loadingEnd()
        }catch(err){
          console.log(err)
          appVue.loadingEnd()
          _this.showErrorMessage("DIF読み込み中にエラーが発生しました。\nDIFファイルの内容が正しいか確認して、再度読み込み直してください。")
          return
        }
      };
      
      reader.onerror = function() {
        console.log("読込エラー")
        appVue.loadingEnd()
        _this.showErrorMessage("DIF読み込み中にエラーが発生しました。\nDIFファイルの内容が正しいか確認して、再度読み込み直してください。")
        return
      };
    },
    readFilePMP: async function(file){
      var appVue = this.$root.$children[0]
      let _this = this
      const columnDef =  {
        55:'inspectionId',
        63:'height',
        64:'weight',
        65:'bmi',
        3:'startDate',
        // 'startTime',
        4:'endDate',
        // 'endTime',
        5:'measurementTime',
        6:'sleepTime',
        8:'SPO2Center',
        9:'SPO2Minimum',
        12:'odi4',
        11:'odi3',
        10:'odi2',
        14:'lessThan90Time',
        15:'lessThan90Ratio',
        16:'pulseAverage',
        82:'selfCheck'
      }
      var patientName = ""
      var item = {}
      // ロード中か判定
      if (!appVue.$data.isLoading) {
        appVue.loadingStart()
      }
      
      // FileReader オブジェクトを作成
      let reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function() {
        try{
          var recordArray =  reader.result.split('\n');
          for (let i = 0; i < recordArray.length; i++){
            if(!columnDef[i]){
              if(i==57){
                patientName = recordArray[i].split(',')[2];
              }
              continue
            }
            let column = recordArray[i].split(',')[2];
            item[columnDef[i]] = column
          }
          if(item["startDate"]){
            var startDate = item["startDate"]
            item["startTime"] = startDate.split(" ")[1] + ":00"
            item["startDate"] = startDate.split(" ")[0]
          }
          if(item["endDate"]){
            var endDate = item["endDate"]
            item["endTime"] = endDate.split(" ")[1] + ":00"
            item["endDate"] = endDate.split(" ")[0]
          }
          if(item["measurementTime"]){
            var measurementTime = item["measurementTime"] * 60
            var measurementTimeHour = ""+(measurementTime/36000|0)+(measurementTime/3600%10|0)
            var measurementTimeMin = ""+(measurementTime%3600/600|0)+(measurementTime%3600/60%10|0)
            var measurementTimeSec = ""+(measurementTime%60/10|0)+(measurementTime%60%10)
            item["measurementTime"] = measurementTimeHour + ":" + measurementTimeMin + ":" + measurementTimeSec
          }
          if(item["sleepTime"]){
            var sleepTime = item["sleepTime"] * 60
            var sleepTimeHour = ""+(sleepTime/36000|0)+(sleepTime/3600%10|0)
            var sleepTimeMin = ""+(sleepTime%3600/600|0)+(sleepTime%3600/60%10|0)
            var sleepTimeSec = ""+(sleepTime%60/10|0)+(sleepTime%60%10)
            item["sleepTime"] = sleepTimeHour + ":" + sleepTimeMin + ":" + sleepTimeSec
          }
          
          // 取込内容のセット
          _this.$set(_this.data,"measurementResult",item)
          if(_this.data.deviceInfo.patientName.replaceAll("　","").replaceAll(" ","")!=patientName.replaceAll("　","").replaceAll(" ","")){
            _this.showErrorMessage("被験者の名前が一致しません。\nCSVファイルの内容が正しいか確認してください。")
          }
          appVue.loadingEnd()
        }catch(err){
          console.log(err)
          appVue.loadingEnd()
          _this.showErrorMessage("CSV読み込み中にエラーが発生しました。\nCSVファイルの内容が正しいか確認して、再度読み込み直してください。")
          return
        }
      };

      reader.onerror = function() {
        console.log("読込エラー")
        appVue.loadingEnd()
        _this.showErrorMessage("CSV読み込み中にエラーが発生しました。\nCSVファイルの内容が正しいか確認して、再度読み込み直してください。")
        return
      };
    },
    readFileSimonJ: async function(file){
      var appVue = this.$root.$children[0]
      let _this = this
      const columnDef =  {
        5:'inspectionId',
        7:'height',
        8:'weight',
        9:'bmi',
        13:'odi3',
        15:'startDate',
        16:'startTime',
        18:'measurementTime',
        23:'analysisTime',
        30:'selfCheck',
        31:'SPO2Center',
        32:'SPO2Minimum',
        33:'SPO2Declines',
        39:'pulseAverage'
      }
      var patientName = ""
      var columns = {}
      // ロード中か判定
      if (!appVue.$data.isLoading) {
        appVue.loadingStart()
      }
      // FileReader オブジェクトを作成
      let reader = new FileReader();
      reader.readAsText(file,'shift-jis');
      reader.onload = function() {
        try{
          var recordArray =  reader.result.split('\n');
          var selfCheckList = ""
          var selfCheckFlag = false
          var selfCheckCnt = 0
          var regexp = new RegExp(/^(.*酸素飽和度低下.*)$/);
          var regex = /,.*$/i;
          for (let i = 0; i < recordArray.length; i++){
            var targetCnt = i - selfCheckCnt
            if(!columnDef[targetCnt]){
              if(i==3){
                patientName = recordArray[i].split(',')[1];
              }
              continue
            }
            if(columnDef[targetCnt] == 'selfCheck' || selfCheckFlag){
              selfCheckList = !selfCheckFlag ? recordArray[i].split(',')[1] : selfCheckList + recordArray[i];
              selfCheckList = selfCheckList.replace(/\r?\n/g, '').replaceAll('\r','')
              if (regexp.test(selfCheckList)) {
                selfCheckFlag = false
              }else{
                selfCheckFlag = true
                selfCheckCnt++
              }
              continue
            }
            columns[columnDef[targetCnt]] = recordArray[i]
            if(recordArray[i].indexOf(",") != -1){
              columns[columnDef[targetCnt]] = recordArray[i].split(',')[1];
            }
            if(columnDef[targetCnt] == 'startDate' || columnDef[targetCnt] == 'startTime' || columnDef[targetCnt] == 'measurementTime' || columnDef[targetCnt] == 'analysisTime'){
              columns[columnDef[targetCnt]] = _this.convertSimonJ(columns[columnDef[targetCnt]])
            }
          }
          columns['selfCheck'] = selfCheckList.replace(regex, '').replaceAll('"','').replaceAll('セルフチェック','')
          
          // 取込内容のセット
          _this.$set(_this.data,"measurementResult",columns)
          if(_this.data.deviceInfo.patientName.replaceAll("　","").replaceAll(" ","") != patientName.replaceAll("　","").replaceAll(" ","").replaceAll('"','')){
            _this.showErrorMessage("被験者の名前が一致しません。\nCSVファイルの内容が正しいか確認してください。")
          }
          appVue.loadingEnd()
        }catch(err){
          console.log(err)
          appVue.loadingEnd()
          _this.showErrorMessage("CSV読み込み中にエラーが発生しました。\nCSVファイルの内容が正しいか確認して、再度読み込み直してください。")
          return
        }
      };
      reader.onerror = function() {
        console.log("読込エラー")
        appVue.loadingEnd()
        _this.showErrorMessage("CSV読み込み中にエラーが発生しました。\nCSVファイルの内容が正しいか確認して、再度読み込み直してください。")
        return
      };
    },
    convertDateFormat: function(val) {
      var calender = {
        "Jan":1,
        "Feb":2,
        "Mar":3,
        "Apr":4,
        "May":5,
        "Jun":6,
        "Jul":7,
        "Aug":8,
        "Sep":9,
        "Oct":10,
        "Nov":11,
        "Dec":12
      }
     var list = val.split(" ")
     return list[2] + "/" + calender[list[1]] + "/" + list[0]
    },
    convertSimonJ: function(val) {
      if(!val) return val
      return val.replaceAll(" ","").replaceAll("　","").replaceAll("年","/").replaceAll("月","/").replaceAll("日","").replaceAll("時",":").replaceAll("分",":").replaceAll("秒","")
    },
    subTime:function() {
      var result, times, second, i,
      len = arguments.length;
      if (len === 0) return;
      for (i = 0; i < len; i++) {
        if (!arguments[i] || !arguments[i].match(/^[0-9]+:[0-9]{2}:[0-9]{2}$/)) continue;
        times = arguments[i].split(':');
        second = this.toSecond(times[0], times[1], times[2]);
        if (!second) continue;
        if (i === 0) {
          result = second;
        } else {
          result -= second;
        }
      }
      return this.toTimeFormat(result);
    },
    toSecond : function(hour, minute, second) {
      // 時間を秒に変換
      if ((!hour && hour !== 0) || (!minute && minute !== 0) || (!second && second !== 0) ||
          hour === null || minute === null || second === null ||
          typeof hour === 'boolean' ||
          typeof minute === 'boolean' ||
          typeof second === 'boolean' ||
          typeof Number(hour) === 'NaN' ||
          typeof Number(minute) === 'NaN' ||
          typeof Number(second) === 'NaN') return;
      return (Number(hour) * 60 * 60) + (Number(minute) * 60) + Number(second);
    },
    toTimeFormat : function(fullSecond) {
      // 秒を時間（hh:mm:ss）のフォーマットに変換
      var hour, minute, second;
      if ((!fullSecond && fullSecond !== 0) || !String(fullSecond).match(/^[\-0-9][0-9]*?$/)) return;
      // var paddingZero = function(n) {
      //     return (n < 10)  ? '0' + n : n;
      // };
      hour   = ('00' + Math.floor(Math.abs(fullSecond) / 3600)).slice(-2);
      minute = ('00' + Math.floor(Math.abs(fullSecond) % 3600 / 60)).slice(-2);
      second = ('00' + Math.floor(Math.abs(fullSecond) % 60)).slice(-2);
      // minute = paddingZero(minute);
      // second = paddingZero(second);
      return ((fullSecond < 0) ? '-' : '') + hour + ':' + minute + ':' + second;
    }
  },
  data() {
    var kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    kenshinDeviceList.unshift({})
    return {
      searchConditions:{
        receiptNumber:"",
        demo:"",
        model:"",
        clientType:"",
        client:"",
        companyName:"",
        applicationDateStart:"",
        applicationDateEnd:"",
        serial: "",
        judgementFlag:""
      },
      role: role,
      hasResult:false,
      searchDatas:[],
      data: {},
      csv: null,
      reportlist:[],
      kenshinDeviceList,
      searchTargetPostCode:"",
      searchTargetAddress:"",
      reasonInputModalActive:false,
      cancelReasonInputModalActive:false,
      reason:"",
      isUpdateModal: false,
      isUpdateCSVModal: false,
      upButtonFile:null,
      screeningFlag:false,
      UploadType:UploadType,
      isWP:false,
      isSimonJ:false,
      isPaginated : true,
      extractDataFlag: false,
      invalidPostcode: false,
    };
  },
  filters: {},
  components: {
    kenshinNavi: naviBar,
    reasonInputModal:reasonInputModal
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
  },
  watch: {
    "data.resultDeliveryInfo.resultDeliveryZip"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
    },
  },
};
</script>
<style lang="scss" scoped>
.addButton {
    margin-left:20px;
}
.dataExtractButton {
    margin-left: auto;
    margin-right: 10px;
}
.resultInput {
    width: 300px !important;
}
a {
  text-decoration: underline;
}
.opration-area {
    height:50px;
    margin-bottom: 10px;
}
.upload_area {
    width: 930px !important;
}
.uplad_button {
    margin-left:20px;
}
.opButton {
  width: 220px;
}
.td_txt {
  width:200px !important;
  margin-top:10px;
}
.passButton {
  margin-left:5px;
  width:120px !important;
  height:29px !important;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
input {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinExtractData.vue